<ng-select
  [loading]="isLoading()"
  [items]="items"
  [formControl]="formControl"
  [virtualScroll]="true"
  [typeahead]="searchTerm$"
  (scrollToEnd)="onScrollToEnd()"
  bindLabel="label"
  bindValue="value"
  dropdownPosition="bottom">
</ng-select>
